export const Global = {
  page: "",
  header:document.querySelector('#l-header'),
  body:document.querySelector('body'),
  menu: document.querySelector(".menu"),
  menuItem: document.querySelectorAll(".menu .menu-inner .list .item"),
  // cursor:document.querySelector('.cursor'),
  // banner:document.querySelector('#l-promotion'),
  lineModal:document.querySelector('#l-lineModal'),
  lowPageList: ["News-low", "Contact-low"],
  isMobile: false,
  isIE: false,
  isEDGE: false,
  // isLogoAnima: false,
  loco: null,
  isTopMvResizeListner:false,
  isTrans: false, // 遷移時 false 遷移終了 true
  isAccess:false,
  currentPage:"Home",
  isBanner:true,
  isLineModal:true,
  isHeadMotionArr:[],
  isHeadAnimaEnd:true,
  isTopMvTimerActive:true,
  isTopMvTimerRestart:false,
  isOpeningOver:false,
};
